"use strict";

var config = require("app/util/config/config");
var PromptList = require("app/shared/components/Prompt/prompt-list");
var PromptContainer = require("app/shared/components/Prompt/prompt-container");
var SAFE_DAYS_TO_UNDO = 7;
var AGENDOR_SUPPORT_PHONE = config.support.phone;
var AGENDOR_SUPPORT_EMAIL = config.support.email;
var PLAN_DOWNGRADE_SECRET_KEY = config.app.planDowngradeSecretKey;

var DowngradePrompt = React.createClass({
  propTypes: {
    redirectUrl: React.PropTypes.string,
    accountLosses: React.PropTypes.object.isRequired,
    onClose: React.PropTypes.func
  },
  getDefaultProps: function() {
    return {
      isOpen: false
    };
  },
  onConfirmDowngrade: function(inputText) {
    if(inputText.value == PLAN_DOWNGRADE_SECRET_KEY){
      window.location.href = this.props.redirectUrl;
      this.props.onClose();
    } else {
      var message = "Entre em contato com a nossa equipe para receber o código e poder prosseguir.";
      this.refs["prompt"].showError(message);
    }
  },
  render: function() {
    var riskProps = {
      type: "prompt",
      title:"Atenção!",
      children: <DowngradePromptContent />,
      hideWarningIcon:false,
      buttonText:"Confirmar perdas e reduzir plano",
      buttonClasses:"btn btn-danger",
      autoClose: false,
      onClose: this.props.onClose,
      isOpen: true,
      onConfirm: this.onConfirmDowngrade
    };

    return <PromptContainer {...riskProps} ref="prompt"></PromptContainer>;
  }
});

const DowngradePromptContent = () => (
  <div className="pt-20 pb-20">
    <p>A redução de plano pode causar perda de informações de sua conta.</p>
    <ul className="ta-l">
      <li>- Usuários que ultrapassaram os limites do plano selecionado serão desativados.</li>
      <li>- Usuários que ultrapassaram os limites do Plano Gratuito serão desativados.</li>
      <li>- Empresas, pessoas e negócios que ultrapassaram os limites do Plano Gratuito serão excluídos.</li>
      <li>- Empresas e pessoas que possuem categoria personalizada ficarão sem categoria definida.</li>
      <li>- Empresas e pessoas que possuem origem personalizada ficarão sem origem definida.</li>
      <li>- Empresas que possuem setor personalizado ficarão sem setor definido.</li>
      <li>- Negócios que possuem etapa personalizada ficarão sem etapa definida.</li>
      <li>- Negócios que possuem motivo de perda personalizado ficarão sem motivo de perda definido.</li>
      <li>- Suas tarefas não serão mais registradas no Google Agenda.</li>
    </ul>

    <p>Para segurança e integridade dos seus dados, caso queira prosseguir, entre em contato com a nossa equipe pelo email <a href={"mailto:" + AGENDOR_SUPPORT_EMAIL}>{AGENDOR_SUPPORT_EMAIL}</a>.</p>
  </div>
);

module.exports = DowngradePrompt;



// WEBPACK FOOTER //
// ./app/screens/Pricing/components/DowngradePrompt/downgrade-prompt.jsx